export default __webpack_public_path__ + "static/media/customer-sapphire.1ededa2b.jpg";